module.exports = __webpack_public_path__ + "img/Facebook_white.76cf54b4.svg";